import { memo } from 'react';
import { StepperProps, Step } from './stepper.types';
import StepperItem from './StepperItem';
import '@/assets/styles/components/stepper.styles.scss';

const Stepper = memo(({ steps, currentStep, completedSteps, stepsProgress, onStepClick }: StepperProps) => {
	return (
		<div className="stepper">
			{steps.map((step: Step) => (
				<StepperItem
					key={step.id}
					step={step}
					currentStep={currentStep}
					completedSteps={completedSteps}
					isActive={currentStep === step.id}
					isCompleted={completedSteps.includes(step.id)}
					progress={stepsProgress[step.id]}
					onClick={onStepClick}
				/>
			))}
		</div>
	);
});

export default Stepper;
